document.addEventListener('DOMContentLoaded', function() {
  if (!customElements.get("tab-collection")) {
    customElements.define(
      "tab-collection",
      class TabCollection extends HTMLElement {
        constructor() {
          super();
          this.initTabCollection();
        }

        initTabCollection() {
          const that = this;
          this.addEventListener('click', function(e) {
            if (e.target.classList.contains('tab_collection_tag')) {
              e.target.classList.add('tc_active');
              e.target.parentNode.querySelectorAll('.tab_collection_tag').forEach((tag) => {
                if (tag !== e.target) {
                  tag.classList.remove('tc_active');
                }
              });

              const _idx = Array.from(that.querySelectorAll('.tab_collection_tag')).indexOf(e.target);
              that.querySelectorAll('.tab-collection-content').forEach((content, index) => {
                if (index === _idx) {
                  content.classList.add('tab_collection_content_active');
                } else {
                  content.classList.remove('tab_collection_content_active');
                }
              });
            }
          });
        }
      }
    );
  }
});
